import React from "react";
import { Form } from "react-bootstrap";

export const POS_ACCESS_DEFAULTS = {
  posBackOffice: false,
  posBackOfficeDashboard: false,
  posBackOfficeLibrary: false,
  posCategories: false,
  posItems: false,
  posSalesTypes: false,
  posBackOfficeIngredient: false,
  posIngredientCategories: false,
  posIngredientLibrary: false,
  posRecipes: false,
  posTab: false,
  posTabLibrary: false,
  posTabCustom: false,
  posTabActivity: false,
  posTabInventory: false,
  posTabShift: false,
};

const groups = [
  {
    title: "POS Back Office",
    parent: "posBackOffice",
    items: [
      ["posBackOfficeDashboard", "Dashboard"],
      ["posBackOfficeLibrary", "Library"],
      ["posCategories", "Categories"],
      ["posItems", "Item Library"],
      ["posSalesTypes", "Sales Type"],
      ["posBackOfficeIngredient", "Ingredient"],
      ["posIngredientCategories", "Ingredient Categories"],
      ["posIngredientLibrary", "Ingredient Library"],
      ["posRecipes", "Recipes"],
    ],
  },
  {
    title: "POS Tab",
    parent: "posTab",
    items: [
      ["posTabLibrary", "Library"],
      ["posTabCustom", "Custom"],
      ["posTabActivity", "Activity"],
      ["posTabInventory", "Inventory"],
      ["posTabShift", "Shift"],
    ],
  },
];

const PosAccessFields = ({ value = POS_ACCESS_DEFAULTS, onChange, readOnly = false }) => {
  const state = { ...POS_ACCESS_DEFAULTS, ...value };
  const setValue = (key, checked) => {
    if (readOnly || !onChange) return;
    onChange({ ...state, [key]: checked });
  };

  return (
    <div className="border rounded p-3 bg-light mt-3">
      <h6 className="mb-3">Hak Akses POS</h6>
      <div className="row g-3">
        {groups.map((group) => (
          <div className="col-lg-6" key={group.title}>
            <div className="card h-100">
              <div className="card-header bg-white fw-semibold">{group.title}</div>
              <div className="card-body">
                <Form.Check
                  type="switch"
                  id={`access-${group.parent}`}
                  label="Aktifkan menu utama"
                  checked={Boolean(state[group.parent])}
                  disabled={readOnly}
                  onChange={(event) => setValue(group.parent, event.target.checked)}
                  className="mb-2"
                />
                {group.items.map(([key, label]) => (
                  <Form.Check
                    type="checkbox"
                    id={`access-${key}`}
                    key={key}
                    label={label}
                    checked={Boolean(state[key])}
                    disabled={readOnly || !state[group.parent]}
                    onChange={(event) => setValue(key, event.target.checked)}
                    className="ms-3 mb-1"
                  />
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
      {!readOnly && <small className="text-muted d-block mt-2">Submenu aktif setelah menu utamanya diaktifkan.</small>}
    </div>
  );
};

export default PosAccessFields;
